import styled from 'styled-components';
import { MultiplePacks } from './multiple-packs';
import { PalletContainerItems } from './pallet-container-items';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export function PackingDetailPacks({
  items,
  isPallet,
  unPackItem,
  loading,
  packages,
  activePackage,
  setActivePackage,
  increaseCount,
  packedItems,
  openLabelGenerationForPackage,
  onOpenPackageCorrection,
  hasShipNode,
  askToPrint,
  fileName,
  setLabelToRefund,
}) {
  const allItemsPacked = packedItems.length === items.length && !isPallet;

  return (
    <Container className={`${allItemsPacked ? 'px-0 col-12 h-100' : 'pr-0 col-6'}`}>
      {isPallet ? (
        <PalletContainerItems items={items} />
      ) : (
        <MultiplePacks
          activePackage={allItemsPacked ? -1 : activePackage}
          allItemsPacked={allItemsPacked}
          askToPrint={askToPrint}
          fileName={fileName}
          hasShipNode={hasShipNode}
          increaseCount={increaseCount}
          items={items}
          loading={allItemsPacked ? loading : false}
          onOpenPackageCorrection={onOpenPackageCorrection}
          openLabelGenerationForPackage={openLabelGenerationForPackage}
          packages={packages}
          setActivePackage={setActivePackage}
          setLabelToRefund={setLabelToRefund}
          unPackItem={unPackItem}
        />
      )}
    </Container>
  );
}
